import React, { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { authAPI } from "../../services/api";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../../styles/Forgot.css"; // Reusing the same styles
import { isPasswordValid, PASSWORD_REQUIREMENT_TEXT } from "../../utils/passwordPolicy";

const ResetPassword = () => {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');

  useEffect(() => {
    if (!token) {
      toast.error("Invalid reset link");
      navigate("/");
    }
  }, [token, navigate]);

  const validatePassword = () => {
    if (!password) {
      toast.warning("Password is required");
      return false;
    }
    if (!isPasswordValid(password)) {
      toast.warning(PASSWORD_REQUIREMENT_TEXT);
      return false;
    }
    if (password !== confirmPassword) {
      toast.error("Passwords do not match");
      return false;
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validatePassword()) return;

    try {
      setLoading(true);
      const response = await authAPI.resetPassword(token, password);

      if (response.status === 200) {
        toast.success("Password reset successful! Redirecting to login...");
        setTimeout(() => navigate("/"), 2000);
      }
    } catch (error) {
      console.error("Reset password error:", error);
      const message = error.response?.data || "Failed to reset password. Please try again.";
      toast.error(typeof message === "string" ? message : JSON.stringify(message));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="forgot-container">
      <div className="forgot-box">
        {/* Logo Section */}
        <div className="forgot-logo-container">
          <div className="forgot-circle-logo">
            <span className="forgot-ats-logo">ATS</span>
          </div>
          <span className="forgot-circle-text">CIRCLE</span>
        </div>

        <h2>Reset Password</h2>
        <p className="forgot-subtext">
          Enter your new password below
        </p>

        <form onSubmit={handleSubmit} className="forgot-form">
          <div className="forgot-form-group">
            <label>New Password *</label>
            <div style={{ position: 'relative' }}>
              <input
                type={showPassword ? "text" : "password"}
                placeholder="Enter new password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                disabled={loading}
                style={{ paddingRight: '40px' }}
              />
              <span
                onClick={() => setShowPassword(!showPassword)}
                style={{
                  position: 'absolute',
                  right: '10px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  cursor: 'pointer',
                  userSelect: 'none'
                }}
              >
                {showPassword ? '👁️' : '👁️‍🗨️'}
              </span>
            </div>
          </div>

          <div className="forgot-form-group">
            <label>Confirm Password *</label>
            <div style={{ position: 'relative' }}>
              <input
                type={showConfirmPassword ? "text" : "password"}
                placeholder="Confirm new password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                disabled={loading}
                style={{ paddingRight: '40px' }}
              />
              <span
                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                style={{
                  position: 'absolute',
                  right: '10px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  cursor: 'pointer',
                  userSelect: 'none'
                }}
              >
                {showConfirmPassword ? '👁️' : '👁️‍🗨️'}
              </span>
            </div>
          </div>

          <button type="submit" className="forgot-btn" disabled={loading}>
            {loading ? "Resetting..." : "Reset Password"}
          </button>

          <p className="forgot-back-link">
            <a href="/" style={{ textDecoration: 'none', color: 'inherit' }}>← Back to Login</a>
          </p>
        </form>
      </div>
    </div>
  );
};

export default ResetPassword;
